module.exports = __webpack_public_path__ + "img/rank-table-guy-1.02abe551.jpg";